var map = {
	"./ion-accordion_2.entry.js": [
		76557,
		68592,
		76557
	],
	"./ion-action-sheet.entry.js": [
		12484,
		86714,
		12484
	],
	"./ion-alert.entry.js": [
		78733,
		86714,
		68592,
		78733
	],
	"./ion-app_8.entry.js": [
		28443,
		68592,
		20305
	],
	"./ion-avatar_3.entry.js": [
		57570,
		57570
	],
	"./ion-back-button.entry.js": [
		31419,
		68592,
		31419
	],
	"./ion-backdrop.entry.js": [
		73788,
		73788
	],
	"./ion-breadcrumb_2.entry.js": [
		44358,
		68592,
		44358
	],
	"./ion-button_2.entry.js": [
		59497,
		59497
	],
	"./ion-card_5.entry.js": [
		49272,
		49272
	],
	"./ion-checkbox.entry.js": [
		12107,
		12107
	],
	"./ion-chip.entry.js": [
		48887,
		48887
	],
	"./ion-col_3.entry.js": [
		98298,
		98298
	],
	"./ion-datetime-button.entry.js": [
		29257,
		56513,
		29257
	],
	"./ion-datetime_3.entry.js": [
		94389,
		56513,
		68592,
		94389
	],
	"./ion-fab_3.entry.js": [
		65599,
		68592,
		65599
	],
	"./ion-img.entry.js": [
		11982,
		11982
	],
	"./ion-infinite-scroll_2.entry.js": [
		87230,
		68592,
		19185
	],
	"./ion-input.entry.js": [
		70880,
		70880
	],
	"./ion-item-option_3.entry.js": [
		40183,
		68592,
		18118
	],
	"./ion-item_8.entry.js": [
		3789,
		68592,
		3789
	],
	"./ion-loading.entry.js": [
		95910,
		68592,
		95910
	],
	"./ion-menu_3.entry.js": [
		87260,
		68592,
		87260
	],
	"./ion-modal.entry.js": [
		33229,
		68592,
		33229
	],
	"./ion-nav_2.entry.js": [
		62631,
		68592,
		62631
	],
	"./ion-picker-column-internal.entry.js": [
		89515,
		89515
	],
	"./ion-picker-internal.entry.js": [
		50236,
		50236
	],
	"./ion-popover.entry.js": [
		63898,
		68592,
		63898
	],
	"./ion-progress-bar.entry.js": [
		10531,
		10531
	],
	"./ion-radio_2.entry.js": [
		22070,
		22070
	],
	"./ion-range.entry.js": [
		67054,
		68592,
		67054
	],
	"./ion-refresher_2.entry.js": [
		40187,
		68592,
		23008
	],
	"./ion-reorder_2.entry.js": [
		65250,
		68592,
		53563
	],
	"./ion-ripple-effect.entry.js": [
		56072,
		56072
	],
	"./ion-route_4.entry.js": [
		32552,
		32552
	],
	"./ion-searchbar.entry.js": [
		51183,
		68592,
		51183
	],
	"./ion-segment_2.entry.js": [
		66487,
		68592,
		66487
	],
	"./ion-select_3.entry.js": [
		84635,
		62888
	],
	"./ion-slide_2.entry.js": [
		80173,
		80173
	],
	"./ion-spinner.entry.js": [
		96436,
		68592,
		96436
	],
	"./ion-split-pane.entry.js": [
		95731,
		95731
	],
	"./ion-tab-bar_2.entry.js": [
		22236,
		68592,
		22236
	],
	"./ion-tab_2.entry.js": [
		5113,
		68592,
		5113
	],
	"./ion-text.entry.js": [
		51622,
		51622
	],
	"./ion-textarea.entry.js": [
		87495,
		87495
	],
	"./ion-toast.entry.js": [
		46217,
		68592,
		46217
	],
	"./ion-toggle.entry.js": [
		77504,
		68592,
		77504
	],
	"./ion-virtual-scroll.entry.js": [
		25473,
		25473
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 50863;
module.exports = webpackAsyncContext;